// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Fr-z","tooltipWrapper":"Gr-z","icon":"Hr-z","tooltip":"Ir-z","content":"Jr-z"};